<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('infirmary')"
                        :isNewButton="tabsIndex===2 && checkPermission('infirmaryuser_createguestuser')"
                        @new-button-click="openStoreGuestModal"
                        :isColumns="true"
                        :other-button="{
                            title:$t('activity_report'),
                            emit:'handleClickActivityReport',
                            show:checkPermission('infirmaryrecord_excelexport'),
                            icon:'ri-file-chart-line'
                        }"
                        @handleClickActivityReport="handleClickActivityReport"
                        @filter-div-status="$refs[tabRefs[tabsIndex]].datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatableColums" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('infirmary')"
                              :isNewButton="false"
                              :isColumns="true"
                              @filter-div-status="$refs[tabRefs[tabsIndex]].datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatableColums" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
                <b-tabs content-class="py-5 position-relative" class="line-tabs" v-model="tabsIndex">
                    <div class="tabs-bottom-line"></div>
                    <b-tab >
                        <template #title>
                            <span>{{$t('student')}}</span>
                        </template>
                        <Student ref="studentRef"  @createNewExamination="createExaminationModal($event)" @openPatientHistoryModal="openPatientHistoryModal($event)" @excelExport="exportExcel($event)"/>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span>{{$t('personnel')}}</span>
                        </template>
                        <Personels ref="personelRef"  @createNewExamination="createExaminationModal($event)" @openPatientHistoryModal="openPatientHistoryModal($event)" @excelExport="exportExcel($event) "/>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span>{{$t('guest')}}</span>
                        </template>
                         <Guest ref="guestRef"  @createNewExamination="createExaminationModal($event)" @openPatientHistoryModal="openPatientHistoryModal($event)" @excelExport="exportExcel($event)"/>
                    </b-tab>
                </b-tabs>
            <CommonModal ref="updatePersonModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <CreateExaminationModal v-if="formProcess==='createExaminationModal'" @createExaminationModal="createExaminationModalHide" :formId="formId"/>
                </template>
            </CommonModal>
            <CommonModal ref="patientHistory" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('patient_history').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <PatientHistory v-if="formProcess==='patient_history'" @createExaminationModal="createExaminationModalHide" :formId="formId"/>
                </template>
            </CommonModal>
            <CommonModal ref="activityReportModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('activity_report').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <ActivityReport v-if="formProcess==='activity_report'" @successActivityReport="successActivityReport" />
                </template>
            </CommonModal>

        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import Student from "@/modules/infirmary/pages/tabs/students/Student.vue";
import Guest from "@/modules/infirmary/pages/tabs/guests/Guest.vue";
import Personels from "@/modules/infirmary/pages/tabs/personels/Personels.vue";
import {EventBus} from '@/main'
import CreateExaminationModal from "@/modules/infirmary/pages/CreateExaminationModal.vue";
import PatientHistory from "@/modules/infirmary/pages/PatientHistory.vue";
import qs from "qs";
import InfirmaryServices from "@/services/InfirmaryServices";
import ActivityReport from "@/modules/infirmary/pages/ActivityReport.vue";
export default {
    components: {
        PatientHistory,
        CreateExaminationModal,
        AppLayout,
        Header,
        HeaderMobile,
        Guest,
        Student,
        Personels,
        ActivityReport
    },
    metaInfo() {
        return {
            title: this.$t('infirmary')
        }
    },
    data() {
        return {
            formId:null,
            formProcess:null,
            tabRefs:[
                'studentRef',
                'personelRef',
                'guestRef',
            ],
            tabsIndex:null,
        }
    },
    mounted() {
        this.tabsIndex=0
    },

    computed:{
       datatableColums(){
           const tabsRef =this.tabRefs[this.tabsIndex]
           if (tabsRef){
               return this.$refs[tabsRef]?.datatable?.columns
           }
           return []
       },
    },
    methods:{
        formClear(){
          this.formProcess=null
          this.formId=null
        },
        openStoreGuestModal(){
            EventBus.$emit('openStoreGuestModal')
        },
        openPatientHistoryModal(id){
            this.formId=id
            this.formProcess='patient_history'
            this.$refs.patientHistory.$refs.commonModal.show()
        },
        createExaminationModal(id){
            this.formId=id
            this.formProcess='createExaminationModal'
            this.$refs.updatePersonModal.$refs.commonModal.show()
        },
        createExaminationModalHide(){
            this.formId=null
            this.formProcess=null
            this.$refs.updatePersonModal.$refs.commonModal.hide()
        },

        handleClickActivityReport(){
            this.formProcess='activity_report'
            this.$refs.activityReportModal.$refs.commonModal.show()
        },
        successActivityReport(){
            this.formProcess=null
            this.$refs.activityReportModal.$refs.commonModal.hide()
        },
        async exportExcel(queryParams) {
            try {
                const config = {
                    ...queryParams,
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };
                const res=await InfirmaryServices.excelExport(config)
                const type  =queryParams.params.filter.type??null
                this._downloadFile(res, this.$t(`${type}`)+'-'+this.$t('infirmary')+'-'+this.$t('report') + '.xlsx')

            }catch (e) {
                this.showErrors(e, null,true)
            }

        }
    }
}
</script>

